import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/Filters/InclusionFilter/useInclusionFilter.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { useStore } from 'effector-react';
import { Card, ClickAwayListener, Collapse, styled } from '@mui/material';
import { Box } from '@gmini/ui-kit/lib/Box';
import { IconButton, Tooltip, FilterList } from '@gmini/ui-kit';
import { goals } from "../../../../metrika";
import * as filter from "./FilterModel";
import { DependencyFilter } from "./DependencyFilter";
import { Title, CardContent, CardHeader, CloseButton, CloseIcon } from "./DependencyFilter.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var useInclusionFilter = function useInclusionFilter() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      seoEventHandler = _ref.seoEventHandler;

  var dependencyFilterApplied = useStore(filter.applied$);
  var inclusionFilterStatus = useStore(filter.byInclusion$);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      filtersOpen = _React$useState2[0],
      setFiltersOpen = _React$useState2[1];

  var toggleFilters = React.useCallback(function (e) {
    e.stopPropagation();
    setFiltersOpen(function (open) {
      return !open;
    });

    if (!filtersOpen) {
      goals.openFilter();
    }
  }, [filtersOpen]);
  var InclusionFilterButton = React.useMemo(function () {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: "\u0424\u0438\u043B\u044C\u0442\u0440\u0430\u0446\u0438\u044F",
      placement: "top",
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: toggleFilters,
        "data-test-id": "filter",
        "data-test-ui-type": "FilterButton",
        selected: dependencyFilterApplied,
        active: filtersOpen,
        children: /*#__PURE__*/_jsx(FilterList, {
          color: "rgba(53, 59, 96, 0.5)"
        })
      })
    });
  }, [dependencyFilterApplied, filtersOpen, toggleFilters]);
  var InclusionFilterContent = React.useMemo(function () {
    return /*#__PURE__*/_jsx(Box, {
      position: "relative",
      children: /*#__PURE__*/_jsx(Box, {
        position: "absolute",
        zIndex: 999999,
        width: "100%",
        children: /*#__PURE__*/_jsx(Collapse, {
          "in": filtersOpen,
          unmountOnExit: true,
          mountOnEnter: true,
          children: /*#__PURE__*/_jsx(ClickAwayListener, {
            onClickAway: function onClickAway() {
              return setFiltersOpen(false);
            },
            children: /*#__PURE__*/_jsxs(FiltersBody, {
              open: filtersOpen,
              children: [/*#__PURE__*/_jsxs(CardHeader, {
                children: [/*#__PURE__*/_jsx(Title, {
                  children: "\u0424\u0438\u043B\u044C\u0442\u0440\u044B"
                }), /*#__PURE__*/_jsx(CloseButton, {
                  onClick: function onClick() {
                    return setFiltersOpen(false);
                  },
                  "data-test-id": "closeFilter",
                  children: /*#__PURE__*/_jsx(CloseIcon, {})
                })]
              }), /*#__PURE__*/_jsx(CardContent, {
                children: /*#__PURE__*/_jsx(DependencyFilter, {
                  seoEventHandler: seoEventHandler
                })
              })]
            })
          })
        })
      })
    });
  }, [filtersOpen, seoEventHandler]);
  return React.useMemo(function () {
    return {
      InclusionFilterButton: InclusionFilterButton,
      InclusionFilterContent: InclusionFilterContent,
      inclusionFilterStatus: inclusionFilterStatus
    };
  }, [InclusionFilterButton, InclusionFilterContent, inclusionFilterStatus]);
};
var FiltersBody = styled(Card)(function (props) {
  return {
    transform: "translateY(".concat(props.open ? 0 : '-100%', ")"),
    transition: props.theme.transitions.create('transform'),
    marginBottom: props.theme.spacing(2),
    boxShadow: '0px 4px 13px rgba(0, 0, 0, 0.15)',
    borderRadius: 0
  };
});